export const cssUtils = {
  leftBorder: (opacity = 50, size = 4) =>
    `border-start ps-2 border-opacity-${opacity} border-${size} border-warning`,
};
